import { useParams } from "react-router-dom"
import { useGetQuizQuery } from "quiz/api/quizzes.endpoints"

export function useQuiz() {
  const { quizId } = useParams<{ quizId: string }>()
  return useGetQuizQuery(quizId!).data
}
